// Streaming Buying persists in-progress flight edits to localStorage so a buyer
// can navigate away mid-order without losing them. Streaming Buying writes the
// entries; Streaming Order Status reads them to flag orders with unsaved work,
// so both pages share the key format from here.
const LOCAL_STORAGE_PREFIX = 'streamingV2OrderView';

export const makeStrBuyingLocalStorageKey = (
  company: string,
  network: string,
  id: string | number | null
): string => `${LOCAL_STORAGE_PREFIX}Company:${company}Network:${network}OrderID:${id}`;

export const getLocalChangesForCompany = (company: string): Record<string, true> => {
  const keyPattern = new RegExp(
    `^${LOCAL_STORAGE_PREFIX}Company:${company}Network:.+?OrderID:(\\d+)$`
  );
  const changed: Record<string, true> = {};
  for (let i = 0; i < window.localStorage.length; i++) {
    const key = window.localStorage.key(i);
    if (!key) continue;
    const match = key.match(keyPattern);
    if (!match) continue;
    const [, id] = match;
    const raw = window.localStorage.getItem(key);
    if (!raw) continue;
    try {
      const value: unknown = JSON.parse(raw);
      const flightChangeMap =
        typeof value === 'object' && value !== null
          ? (value as { flightChangeMap?: Record<string, unknown> }).flightChangeMap
          : undefined;
      if (flightChangeMap && Object.keys(flightChangeMap).length > 0) {
        changed[id] = true;
      }
    } catch {
      // Ignore malformed JSON entries.
    }
  }
  return changed;
};
